import { render, staticRenderFns } from "./DdjsMainView.vue?vue&type=template&id=c068af96&"
import script from "./DdjsMainView.vue?vue&type=script&lang=js&"
export * from "./DdjsMainView.vue?vue&type=script&lang=js&"
import style0 from "./DdjsMainView.vue?vue&type=style&index=0&id=c068af96&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports